export type InsuranceProvider = keyof typeof InsuranceProviders

export const InsuranceProviders = {
  Ethos: 'Ethos',
  EthosWholeLife: 'EthosWholeLife',
} as const;


